import { create } from 'zustand';

import { ALERT_SOUND_STORAGE_KEY } from '../constants/alert-sound.js';

type AlertSoundState = {
  enabled: boolean;
  blocked: boolean;
  setEnabled: (enabled: boolean) => void;
  setBlocked: (blocked: boolean) => void;
};

// Private browsing and blocked site data make storage access throw; the sound then stays on.
const readStoredEnabled = (): boolean => {
  try {
    return localStorage.getItem(ALERT_SOUND_STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
};

const writeStoredEnabled = (enabled: boolean): void => {
  try {
    localStorage.setItem(ALERT_SOUND_STORAGE_KEY, String(enabled));
  } catch {
    // The in-memory preference still applies for this session.
  }
};

export const useAlertSoundStore = create<AlertSoundState>((set) => ({
  enabled: readStoredEnabled(),
  blocked: false,
  // Toggling is itself a user gesture, which lifts the autoplay block.
  setEnabled: (enabled) => {
    writeStoredEnabled(enabled);
    set({ enabled, blocked: false });
  },
  setBlocked: (blocked) => set({ blocked }),
}));
